import React,{Component} from 'react';
import {Container,Row,Col} from 'react-bootstrap';

function Page404({state,updateState,loadData}){
  const {openMenu} = state;
  return(
    <>
      <div className={`ws_content_wrapper ${(!openMenu) ? 'wrapper_close' : ''}`}>
        <div className="ws_content_header ws_pl_0 ws_pr_0 mb-5">
          <h1 className="ws_title_header">Page 404</h1>
          <Container fluid>
            <Row>
              <Col xs={12}>
    
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  )
}

export default Page404;